import useLocalStorage from '~hooks/useLocalStorage';
import { getSidebar, getUser } from '~services/core';

export const updateUserNavigation = async () => {
  const { updateUserData, removeUserData } = useLocalStorage();

  const user = await getUser();
  const sidebar = await getSidebar();

  if (user && sidebar) {
    updateUserData({ ...user, sidebar });
    window.location.reload();
  } else removeUserData();
};
